import React, { useCallback } from 'react';
import { HeroSection, IntroSection, WhyNowSection, WhatWeHireSection, ApproachSection, WhyChooseUsSection, SpecialisationSection, BestForSection, CTASection } from './leadership-hiring/Sections';
import { AboutSameerSection, WhyChooseAvantGardeSection } from './leadership-hiring/AboutSections';
import { ConsultationFormSection } from './leadership-hiring/ConsultationForm';
import { BrochureTicker } from './leadership-hiring/BrochureTicker';

export default function LeadershipHiringPage() {
  const scrollToConsultation = useCallback(() => {
    document.getElementById('consultation-form')?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <div>
      <HeroSection />
      <IntroSection />
      <WhyNowSection onScrollToConsultation={scrollToConsultation} />
      <WhatWeHireSection />
      <ApproachSection />
      <WhyChooseUsSection />
      <SpecialisationSection />
      <AboutSameerSection />
      <WhyChooseAvantGardeSection />
      <BestForSection />
      <ConsultationFormSection />
      <CTASection />
      <BrochureTicker />
    </div>
  );
}
